export default __webpack_public_path__ + "static/media/11.23.c11951cb.jpg";